import { type FC } from 'react';

import { PublisherCardLayout } from './internal/components/PublisherCardLayout/PublisherCardLayout';
import { type PublisherCardLayoutContainerProps } from './internal/types';

export const PublisherCardLayoutContainer: FC<PublisherCardLayoutContainerProps> = props => {
  const { avatar, type, nameWithBadges, documentsChecked, contactActions, brandingLevel } = props;

  return (
    <PublisherCardLayout
      avatar={avatar}
      brandingLevel={brandingLevel}
      contactActions={contactActions}
      documentsChecked={documentsChecked}
      nameWithBadges={nameWithBadges}
      type={type}
    />
  );
};
